// extracted by mini-css-extract-plugin
module.exports = {"TrainerBubble":"StickyChatToggle_TrainerBubble__3ZGBx","Show":"StickyChatToggle_Show__2BRzq"};